export default function formatTime () {
    let initial = new Date().toLocaleTimeString();
    let analog = initial.split(' ')[1] || null;
    let hours = initial.split(' ')[0].split(':')[0];
    let minutes = initial.split(' ')[0].split(':')[1];
    let message = analog ? (hours + ':' + minutes + ' ' + analog) : (hours + ':' + minutes)
    return message 
  }